var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadysetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1 24.4C9.39997 22.7 7.49997 18.6 8.49997 14.6C4.19997 12.2 1.79997 7.50001 2.39997 2.50001C7.39997 1.90001 12.1 4.30001 14.5 8.60001C18.5 7.60001 22.6 9.50001 24.3 13.2C16.7 10.5 10.5 16.7 13.1 24.4Z",
    fill: "#8E24AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1 24.4C9.39997 22.7 7.49997 18.6 8.49997 14.6C4.19997 12.2 1.79997 7.50001 2.39997 2.50001C7.39997 1.90001 12.1 4.30001 14.5 8.60001C18.5 7.60001 22.6 9.50001 24.3 13.2C16.7 10.5 10.5 16.7 13.1 24.4Z",
    fill: "#8E24AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4 23.4C22 23.2 19.6 22.8 17.9 21.7C12.5 18.5 18.5 12.5 21.8 17.8C22.8 19.6 23.3 22 23.4 23.4Z",
    fill: "#8E24AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4001 0H12.8L17.6 4.8H32.4001C38.7001 4.8 43.9001 10 43.9001 16.3V18C43.9001 21.7 42.1 25.3 39 27.4L38.2001 28L41.7001 31.5L42.3 31.1C46.4 28 48.8 23.2 48.8 18.1V16.4C48.8 7.3 41.4001 0 32.4001 0Z",
    fill: "#8E24AA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 44.6L27.2 23.8L23.8 27.2L40.5 43.9H16.8C10.2 43.9 4.8 38.5 4.8 31.9V17.5L0 12.7V31.9C0 41.2 7.6 48.7 16.8 48.7H46.3C47.3 48.7 48.2 48.1 48.5 47.2C48.9 46.3 48.7 45.3 48 44.6Z",
    fill: "#8E24AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadysetIcon);
export default __webpack_public_path__ + "static/media/readyset-icon.47d28c08151603b944a917fda60854c3.svg";
export { ForwardRef as ReactComponent };